import { cn } from "@/lib/utils";
import { Typography, badgeVariants } from "@backpac/monica";

interface RegisterMethodRadioProps {
  value: "google" | "manual";
  onValueChange?: (option: "google" | "manual") => void;
  className?: string;
}

export function RegisterMethodRadio({ value, onValueChange, className }: RegisterMethodRadioProps) {
  return (
    <div className={cn("space-y-4", className)}>
      <button
        className={cn(
          "flex gap-3 rounded-[12px] p-6 box-border relative w-full",
          "before:absolute before:inset-0 before:rounded-[12px] before:border before:border-borderLight",
          value === "google" && "before:border-textPrimary before:border-2",
        )}
        type="button"
        onClick={() => onValueChange?.("google")}
      >
        <i className="inline-block i-bp-google w-4 h-4 flex-shrink-0" />
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-[6px]">
            <Typography size="sm" weight={600}>
              Sign in with Google
            </Typography>
            <div className={cn(badgeVariants({ theme: "blue" }))}>Instant</div>
          </div>
          <Typography size="paragraphXs" color="textMuted" className="text-left">
            Easily add your YouTube channel by signing in with Google for a quicker setup.
          </Typography>
        </div>
        <RadioIcon selected={value === "google"} className="ml-auto my-auto" />
      </button>
      <button
        className={cn(
          "flex gap-3 rounded-[12px] p-6 box-border relative w-full",
          "before:absolute before:inset-0 before:rounded-[12px] before:border before:border-borderLight",
          value === "manual" && "before:border-textPrimary before:border-2",
        )}
        type="button"
        onClick={() => onValueChange?.("manual")}
      >
        <i className="inline-block i-bp-link w-4 h-4 flex-shrink-0" />
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-[6px]">
            <Typography size="sm" weight={600}>
              Enter YouTube Channel URL
            </Typography>
          </div>
          <Typography size="paragraphXs" color="textMuted" className="text-left">
            Manually enter your YouTube channel URL and verify it with a code.
          </Typography>
        </div>
        <RadioIcon selected={value === "manual"} className="ml-auto my-auto" />
      </button>
    </div>
  );
}

function RadioIcon({ selected, className }: { selected: boolean; className?: string }) {
  return (
    <i
      className={cn(
        "inline-block flex-shrink-0 size-5",
        selected ? "i-bp-radio-selected" : "i-bp-radio-default",
        className,
      )}
    />
  );
}
